import { UseQueryResult } from "@tanstack/react-query";
import { AxiosHeaders } from "axios";

import { UseFetchOptions } from "../types/StoryblokTypes";
import { DepartmentStory } from "../types/DepartmentTypes";
import { useStoryblokProxy } from "./useStoryblokProxy";

interface DepartmentResponse {
  storyData: DepartmentStory[];
  headers: AxiosHeaders;
}

export const useDepartments = (
  args: UseFetchOptions,
  abortRequest?: boolean
): UseQueryResult<DepartmentResponse> => {
  const storyblokData = useStoryblokProxy(args, abortRequest);

  return {
    ...storyblokData,
    data: {
      storyData: storyblokData.data?.stories,
      headers: storyblokData.data?.headers,
    },
  } as unknown as UseQueryResult<DepartmentResponse>;
};
